import { OTLayout } from "@/components/layout/ot-layout";
import { EventsList } from "@/components/events/events-list";

export default function OTEvents() {
  return (
    <OTLayout title="Events">
      <EventsList
        intro="RCOT conferences, SS Rheumatology study days, COT Fatigue Programme updates, HCPC CPD events, and more — UK occupational therapy events relevant to rheumatology in one place."
        accentBg="bg-pink-100"
        accentIcon="text-pink-700"
        accentLink="text-pink-600 hover:text-pink-800"
      />
    </OTLayout>
  );
}
